let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dbGVv")).then(() => parcelRequire('bwYWn'));